import React from "react";
// REDUX
import { useSelector } from "react-redux";
// COMPONENTS
import OffsetTypeConfigurationTable from "./OffsetTypeTable";
import OffsetTypeForm from "./OffsetTypeForm";
import OffsetTypeDrawer from "./OffsetTypeDrawer";
import OffsetTypeDeleteModal from "./OffsetTypeDeleteModal";
// AUTHORIZATION
import { Permission, hasPermission } from "../../../utils/validatePermissions";
import UnauthorizedPage from "../../unauthorized/UnauthorizedPage";
// INTERFACES
import { RootState } from "../../../app/store";

const OffsetTypePage = () => {
  // ************************************************ */
  // LOCAL STORAGE AND VARIABLES ******************** */
  const { permissionSet } = useSelector((state: RootState) => state.user);
  const { theme } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      {hasPermission(Permission.ViewToolManagementOffsetTypes, permissionSet ?? []) ? (
        <div className={`layout__contentPage__${theme}`}>
          <OffsetTypeConfigurationTable />
          <OffsetTypeForm />
          <OffsetTypeDrawer />
          <OffsetTypeDeleteModal />
        </div>
      ) : (
        <UnauthorizedPage />
      )}
    </div>
  );
};

export default OffsetTypePage;
